"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _TextButton = require("../TextButton");

var _Card = require("../Card");

var _Icon = require("../Icon");

var _Typography = require("../Typography");

var _theme = require("../../theme");

var _jsxRuntime = require("react/jsx-runtime");

var variants = {
  danger: _theme.palette.error.main,
  info: _theme.palette.primary.dark,
  secondary: _theme.palette.brand.purple,
  success: _theme.palette.success.dark
};
var variantIcons = {
  danger: "exclamation-triangle",
  info: "exclamation-triangle",
  secondary: "exclamation-triangle",
  success: "check-circle"
};
var StyledCard = (0, _material.styled)(_Card.Card, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "bannerVariant";
  }
})(function (_ref) {
  var theme = _ref.theme,
      bannerVariant = _ref.bannerVariant;
  return {
    backgroundColor: variants[bannerVariant],
    borderRadius: "0",
    color: "white",
    padding: theme.spacing(3)
  };
});
var StyledTextButton = (0, _material.styled)(_TextButton.TextButton, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "actionType";
  }
})(function (_ref2) {
  var theme = _ref2.theme,
      actionType = _ref2.actionType;
  return {
    "&:hover, &:focus": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      borderColor: "white",
      color: "white"
    },
    backgroundColor: actionType === "primary" ? "white" : "transparent",
    borderColor: "white",
    color: actionType === "primary" ? theme.palette.brand.grey.charcoal : "white",
    marginLeft: theme.spacing(3)
  };
});

var Banner = function Banner(_ref3) {
  var _ref3$actions = _ref3.actions,
      actions = _ref3$actions === void 0 ? [] : _ref3$actions,
      _ref3$cypressType = _ref3.cypressType,
      cypressType = _ref3$cypressType === void 0 ? "" : _ref3$cypressType,
      bannerTypeText = _ref3.bannerTypeText,
      descriptionText = _ref3.descriptionText,
      variant = _ref3.variant,
      _ref3$showIcon = _ref3.showIcon,
      showIcon = _ref3$showIcon === void 0 ? true : _ref3$showIcon;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCard, {
    bannerVariant: variant,
    "data-cy": cypressType,
    raised: true,
    role: "alert",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      children: [showIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: "white",
        iconName: variantIcons[variant],
        iconStyle: "fas",
        ml: 0,
        style: {
          flexBasis: "4rem",
          fontSize: "3rem"
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.Typography, {
        color: "inherit",
        sx: {
          flexGrow: 1,
          flexShrink: 1,
          marginLeft: function marginLeft(theme) {
            return theme.spacing(3);
          }
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: bannerTypeText
        }), " ", descriptionText]
      }), actions && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          flexBasis: "auto",
          flexShrink: 0
        },
        children: actions.map(function (action) {
          if (action.href) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTextButton, {
              actionType: action.type,
              component: "a",
              "data-cy": action.cypress,
              href: action.href,
              label: action.text,
              size: "large",
              target: action.target,
              variant: action.type === "primary" ? "contained" : "outlined"
            }, action.text);
          } else {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTextButton, {
              actionType: action.type,
              "data-cy": action.cypress,
              label: action.text,
              onClick: action.action,
              size: "large",
              variant: action.type === "primary" ? "contained" : "outlined"
            }, action.text);
          }
        })
      })]
    })
  });
};

var _default = Banner;
exports.default = _default;